import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'ag1-progress-ring',
  templateUrl: './ag1-progress-ring.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Ag1ProgressRingComponent {
  value = input<number>(0);

  strokeWidth: number = 15;

  //The reason for the 100 - percentage calculation lies in how the stroke-dashoffset property works in CSS/SVG,
  //as `stroke-dashoffset` defines how much of the line is hidden, not how much is shown.
  //This means that the higher the value, the more of the line is hidden, and the lower the value, the more of the line is shown.
  //Therefore, we need to subtract the value from 100 to get the correct percentage.
  completedPercentage = computed(() => {
    if (this.value() > 100) {
      return 0;
    }

    if (this.value() <= 0) {
      return 100;
    }

    return 100 - this.value();
  });
}
